<template>
  <div class="about">
    <about-chat-r-d-g />
  </div>
</template>

<script>
// @ is an alias to /src
import AboutChatRDG from "@/components/AboutChatRDG.vue";

export default {
  name: "ChatBotView",
  components: {
    AboutChatRDG,
  },
};
</script>
